import {
  Autocomplete,
  Box,
  Button,
  Chip,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Tab,
  Tabs,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMarketPlaces } from "../../../../redux/actions/marketplacesActions";
import { getOutwardBrands } from "../../../../redux/actions/BrandAction";
import {
  addMarketPlaceBrand,
  deleteMarketPlaceBrand,
} from "../../../../redux/actions/marketpleacesBrandAction";
import useAlert from "../../../../hooks/useAlert";
import brandService from "../../../../services/BrandService";
import ecommercePlaceService from "../../../../services/ecommercePlaceService";
import marketplacesService from "../../../../services/marketplacesService";
import outWardService from "../../../../services/outWardService";
import { getEcommercePlaces } from "../../../../redux/actions/ecommercePlaceActions";
import PropTypes from "prop-types";
import { unwrapThunkList } from "../../../../utils/helpers";

const BrandMatching = ({ open, handleClose, brandData }) => {
  const { showSuccessAlertMarketpleaceBrand, showErrorAlertMarketpleaceBrand } =
    useAlert();
  const [selectedPlace, setSelectedPlace] = useState(null);
  const [marketPlaceName, setMarketPlaceName] = useState(null);
  const [allPlaces, setAllPlaces] = useState([]);
  const [selectedTab, setSelectedTab] = useState(0);
  const dispatch = useDispatch();
  const userId = useSelector((state) => state?.auth?.user?.id);
  const token = useSelector((state) => state?.auth?.user?.accessToken?.token);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [allAccounts, setAllAccounts] = useState([]);
  const [ecommerceAccounts, setEcommerceAllAccounts] = useState([]);
  const [marketpleacesAccounts, setMarketpleacesAllAccounts] = useState([]);
  const [outWardBrand, setOutWardBrand] = useState([]);
  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "95%", sm: "600px" },
    maxWidth: "600px",
    bgcolor: "background.paper",
    boxShadow: 24,
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    height: { xs: "90vh", sm: "500px" },
    borderRadius: 2,
    overflow: "hidden",
  };
  const [brand, setBrand] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    const fetchData = async () => {
      getBrandDetail();
    };

    if (brandData?.id) {
      fetchData();
    }
  }, [brandData, token]);

  const getBrandDetail = async () => {
    const detail = await brandService.getBrandDetailApi(brandData?.id, token);

    setBrand(detail?.data?.data?.data[0]);
  };
  const sideMenuStyle = {
    width: { xs: "100%", sm: "60%" },
    borderRight: { xs: "none", sm: "1px solid #ddd" },
    borderBottom: { xs: "1px solid #ddd", sm: "none" },
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    maxHeight: { xs: "200px", sm: "100%" },
    overflow: "auto",
  };
  const handleCloseModal = () => {
    resetModal();
    handleClose();
    setSelectedTab(0);
  };

  const handleTabChange = async (event, newValue) => {
    // if (newValue == 2) {
    //     newValue = 4;
    // }
    let selected = allPlaces[newValue];
    setOutWardBrand([]);

    if (!selected) {
      selected = {
        id: 11,
        name: "+",
        iconLink: "",
        colorCode: "#3f3f3f",
        type: "marketplace",
      };
    } else {
      setSelectedPlace(selected);
      setMarketPlaceName(selected.name);
    }

    const selectedPlace1 = selected;
    const marketPlaceName1 = selectedPlace1?.name;

    if (!marketPlaceName1) {
      console.error("Seçilen tab için geçerli bir pazaryeri bulunamadı!");
      return;
    }
    const requestBody = createRequestBody(marketPlaceName1);
    try {
      if (marketPlaceName1 != "Hepsiburada") {
        // dispatch(getOutwardBrands(marketPlaceName1, requestBody, token));
      }
    } catch (error) {
      console.error(
        "API Hatası:",
        error.response ? error.response.data : error.message
      );
    }

    setSelectedTab(newValue);
  };
  const createRequestBody = (selectedPlaceName) => {
    const marketPlaceSettings = marketpleacesAccounts
      .filter((account) => account.marketPlaceName === selectedPlaceName)
      .map((account) => ({
        id: 0,
        userId: account.userId,
        marketPlaceId: account.marketPlaceId || 0,
        marketPlaceName: account.marketPlaceName,
        valueId: account.valueId,
        value: account.value,
        createDate: new Date().toISOString(),
        updateDate: new Date().toISOString(),
        ia: true,
      }));

    const ecommercePlaceSettings = ecommerceAccounts
      .filter((account) => account.ecommercePlaceName === selectedPlaceName)
      .map((account) => ({
        id: 0,
        userId: account.userId,
        ecommercePlaceId: account.ecommercePlaceId || 0,
        ecommercePlaceName: account.ecommercePlaceName,
        valueId: account.valueId,
        value: account.value,
        createDate: new Date().toISOString(),
        updateDate: new Date().toISOString(),
        ia: true,
      }));

    return {
      marketPlaceSetting: marketPlaceSettings,
      ecommercePlaceSettings: ecommercePlaceSettings,
      name: debouncedText,
    };
  };

  const resetModal = () => {
    setAllPlaces([]);
    setAllAccounts([]);
    setSelectedTab(0);
    setError(null);
    setLoading(false);
  };
  useEffect(() => {
    const fetchData = async () => {
      if (open) {
        setLoading(true);
        try {
          const [marketResponse] = await Promise.all([
            dispatch(getMarketPlaces(token)),
          ]);
          const [ecommerceResponse] = await Promise.all([
            dispatch(getEcommercePlaces(token)),
          ]);
          let ecommerceList = unwrapThunkList(ecommerceResponse).filter(
            (k) => k.name === "Ikas"
          );
          const marketList = unwrapThunkList(marketResponse).filter(
            (k) =>
              k.name === "Hepsiburada" ||
              k.name === "Trendyol" ||
              k.name === "Pazarama" ||
              k.name === "TrendPiyasa" ||
              k.name === "Idefix"
          );
          const combinedData = [...marketList, ...ecommerceList];
          setAllPlaces(combinedData);
          setLoading(false);
        } catch (err) {
          setError(err.message || "Veriler alınırken hata oluştu.");
          setLoading(false);
        }
      }
    };

    fetchData();
  }, [open, dispatch, token]);

  const [searchText, setSearchText] = useState("");
  const [debouncedText, setDebouncedText] = useState("");
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedText(searchText);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchText]);

  const GetBrand = async () => {
    try {
      const requestBody = createRequestBody(marketPlaceName);

      setLoading(true);
      setOutWardBrand([]);
      if (requestBody.name != null) {
        const response = await outWardService.fetchBrand(
          marketPlaceName,
          requestBody,
          token
        );
        setOutWardBrand(response);
      }
      setLoading(false);
    } catch (exx) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (debouncedText) {
      GetBrand();
    }
  }, [debouncedText, dispatch, token]);

  const [selectedBrand, setSelectedBrand] = useState(null); // Seçilen marka
  const [selectedBrandImput, setSelectedBrandImput] = useState(null); // Seçilen marka hepsiburadaiçin

  const saveMarketpleacesBrand = async () => {
    let matchingData = null;

    if (marketPlaceName == "Ikas") {
      matchingData = {
        ecommercePlaceId: selectedPlace?.id,
        marketPlaceName: selectedPlace?.name,
        marketPlaceBrandId: selectedBrand?.id,
        brandId: brand?.id,
        marketPlaceBrandName: selectedBrand?.name,
      };
    } else if (marketPlaceName !== "Hepsiburada") {
      matchingData = {
        marketPlaceId: selectedPlace?.id,
        marketPlaceName: selectedPlace?.name,
        marketPlaceBrandId: selectedBrand?.id,
        brandId: brand?.id,
        marketPlaceBrandName: selectedBrand?.name,
      };
    } else {
      matchingData = {
        marketPlaceId: selectedPlace?.id,
        marketPlaceName: selectedPlace?.name,
        brandId: brand?.id,
        marketPlaceBrandName: selectedBrandImput,
      };
    }
    try {
      await dispatch(addMarketPlaceBrand(matchingData, token));
      showSuccessAlertMarketpleaceBrand();
      getBrandDetail();
    } catch (error) {
      showErrorAlertMarketpleaceBrand();
      console.error("Marka eklenirken hata oluştu:", error.message || error);
    }
  };
  useEffect(() => {
    if (open && allPlaces.length > 0) {
      handleTabChange(1, selectedTab);
    }
  }, [open, allPlaces, selectedTab]);

  const handleDeleteCategory = async (originalId) => {
    if (!originalId) {
      console.warn("Silinecek marka ID'si eksik!");
      return;
    }
    try {
      await dispatch(deleteMarketPlaceBrand(originalId, token));
      showSuccessAlertMarketpleaceBrand();
      getBrandDetail();
    } catch (error) {
      showErrorAlertMarketpleaceBrand();
      console.error("marka silinirken hata oluştu:", error?.message || error);
    }
  };

  useEffect(() => {
    const fetchAccounts = async () => {
      try {
        const response = await marketplacesService.getMarketPlacesAccountsApi(
          userId
        );
        setMarketpleacesAllAccounts(response?.data?.data?.data);
      } catch (err) {
        setError(
          err.response?.data?.message ||
            "Hesap bilgileri alınırken hata oluştu."
        );
      }
    };
    const fetchAccountsEcommerce = async () => {
      try {
        const response =
          await ecommercePlaceService.getEcommercePlaceAccountsApi(userId);
        setEcommerceAllAccounts(response?.data?.data?.data);
      } catch (err) {
        setError(
          err.response?.data?.message ||
            "Hesap bilgileri alınırken hata oluştu."
        );
      }
    };
    fetchAccounts();
    fetchAccountsEcommerce();
  }, [userId]);
  return (
    <Modal
      open={open}
      onClose={handleCloseModal}
      aria-labelledby="category-matching-title"
      aria-describedby="category-matching-description"
    >
      <Box sx={modalStyle}>
        <Box sx={sideMenuStyle}>
          {loading ? (
            <Box sx={{ display: "flex", justifyContent: "center", p: 2 }}>
              <CircularProgress />
            </Box>
          ) : (
            <Tabs
              orientation={isMobile ? "horizontal" : "vertical"}
              value={selectedTab}
              onChange={handleTabChange}
              aria-label="Kategori Tabs"
              variant={isMobile ? "scrollable" : "standard"}
              scrollButtons="auto"
              sx={{
                "& .MuiTab-root": {
                  minWidth: { xs: "auto", sm: "160px" },
                  fontSize: { xs: "0.875rem", sm: "1rem" },
                  padding: { xs: "8px 16px", sm: "12px 24px" },
                },
              }}
            >
              {allPlaces.map((place) => (
                <Tab
                  key={`${place.type}-${place.id}`}
                  label={place.name}
                  sx={{
                    textTransform: "none",
                    fontWeight: 500,
                  }}
                />
              ))}
              <Tab
                key={0}
                label={
                  <span
                    style={{
                      fontSize: { xs: "24px", sm: "30px" },
                      fontWeight: "bold",
                    }}
                  >
                    +
                  </span>
                }
              />
            </Tabs>
          )}
        </Box>
        <Box
          sx={{
            flex: 1,
            overflow: "auto",
            p: { xs: 2, sm: 3 },
          }}
        >
          {allPlaces[selectedTab]?.name != undefined ? (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography
                  variant="h6"
                  sx={{
                    textAlign: "center",
                    fontWeight: "bold",
                    mb: { xs: 2, sm: 3 },
                    mt: { xs: 1, sm: 1 },
                    fontSize: { xs: "1.1rem", sm: "1.25rem" },
                  }}
                >
                  {allPlaces[selectedTab]?.name || "Marka Seç"}
                </Typography>

                {brand && (
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: "bold",
                      mb: { xs: 2, sm: 3 },
                      textAlign: "center",
                      fontSize: { xs: "0.875rem", sm: "1rem" },
                      color: "text.secondary",
                    }}
                  >
                    Seçilen Marka: {brandData?.name}
                  </Typography>
                )}

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    mb: 2,
                  }}
                >
                  {marketPlaceName != "Hepsiburada" ? (
                    <Autocomplete
                      onInputChange={(event, newInputValue) =>
                        setSearchText(newInputValue)
                      }
                      onChange={(event, value) => setSelectedBrand(value)}
                      disablePortal
                      options={outWardBrand}
                      getOptionLabel={(option) => option.name || ""}
                      sx={{
                        width: { xs: "100%", sm: 300 },
                        "& .MuiOutlinedInput-root": {
                          fontSize: { xs: "0.875rem", sm: "1rem" },
                        },
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Ara"
                          size={isMobile ? "small" : "medium"}
                        />
                      )}
                      disabled={brand?.marketPlaceBrands?.some((marketBrand) =>
                        marketBrand?.marketPlaceId == null
                          ? marketBrand?.ecommercePlaceId === selectedPlace?.id
                          : marketBrand?.marketPlaceId === selectedPlace?.id
                      )}
                    />
                  ) : (
                    <TextField
                      sx={{
                        width: { xs: "100%", sm: 300 },
                        "& .MuiOutlinedInput-root": {
                          fontSize: { xs: "0.875rem", sm: "1rem" },
                        },
                      }}
                      id="outlined-basic"
                      label="Marka"
                      variant="outlined"
                      size={isMobile ? "small" : "medium"}
                      value={selectedBrandImput || ""}
                      onChange={(event) =>
                        setSelectedBrandImput(event.target.value)
                      }
                      disabled={brand?.marketPlaceBrands?.some(
                        (marketBrand) =>
                          marketBrand?.marketPlaceId === selectedPlace?.id
                      )}
                    />
                  )}
                </Box>

                {brand?.marketPlaceBrands?.length > 0 && selectedPlace && (
                  <Box
                    sx={{
                      mt: 2,
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 1,
                      justifyContent: "center",
                    }}
                  >
                    {brand?.marketPlaceBrands
                      ?.filter((marketBrand) =>
                        marketBrand?.marketPlaceId == null
                          ? marketBrand?.ecommercePlaceId === selectedPlace?.id
                          : marketBrand?.marketPlaceId === selectedPlace?.id
                      )
                      .map((matchedBrand, index) => (
                        <Chip
                          key={matchedBrand.id}
                          label={matchedBrand.marketPlaceBrandName}
                          onDelete={() => handleDeleteCategory(matchedBrand.id)}
                          color="primary"
                          sx={{
                            fontSize: { xs: "0.75rem", sm: "0.875rem" },
                            padding: { xs: "4px 8px", sm: "8px" },
                            backgroundColor: "secondary.light",
                            color: "white",
                            "&:hover": {
                              backgroundColor: "secondary.main",
                            },
                          }}
                        />
                      ))}
                  </Box>
                )}
              </Grid>
            </Grid>
          ) : (
            <Grid
              container
              direction="column"
              alignItems="center"
              justifyContent="center"
              sx={{ mt: 4 }}
            >
              <Typography
                variant="h6"
                sx={{
                  textAlign: "center",
                  fontWeight: "bold",
                  mb: 3,
                  fontSize: { xs: "1.1rem", sm: "1.25rem" },
                }}
              >
                Yeni Pazaryeri Eklemek İçin
              </Typography>

              <Button
                variant="contained"
                startIcon={<span>+</span>}
                sx={{
                  bgcolor: "#1E88E5",
                  borderRadius: 28,
                  px: { xs: 2, sm: 3 },
                  py: { xs: 0.5, sm: 1 },
                  color: "white",
                  fontSize: { xs: "0.875rem", sm: "1rem" },
                  "&:hover": {
                    bgcolor: "#1565C0",
                  },
                }}
                onClick={() => (window.location.href = "/Application")}
              >
                Ekle
              </Button>
            </Grid>
          )}

          {/* Sağ alt köşedeki buton */}
          <Box
            sx={{
              position: { xs: "static", sm: "absolute" },
              bottom: { xs: "auto", sm: 16 },
              right: { xs: "auto", sm: 16 },
              mt: { xs: 2, sm: 0 },
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={saveMarketpleacesBrand}
              sx={{
                textTransform: "none",
                fontWeight: "bold",
                fontSize: { xs: "0.875rem", sm: "1rem" },
                padding: { xs: "6px 12px", sm: "8px 16px" },
                borderRadius: 2,
                width: { xs: "100%", sm: "auto" },
              }}
            >
              Kaydet
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

BrandMatching.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  brandData: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
};

export default BrandMatching;
